import type { ApiContext } from "@hobbyshopify/backend-client";
import { type AuthContextProvider, AuthHandler } from "trunk.js";

/**
 * There is no re-authentication flow: a 401 means the Firebase session ended,
 * and the app root re-checks the session on its own. So a failed call goes
 * straight back to its caller. The backend client's `ApiNotAuthorized` is not
 * trunk's class, so `onAuthFailure` is not reached today; `cancel()` is what it
 * would do anyway.
 */
export function createAuthHandler(session: AuthContextProvider<ApiContext>): AuthHandler<ApiContext> {
  return new AuthHandler({ provider: session, onAuthFailure: (call) => call.cancel() });
}
